import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { MicroempresarioService } from 'src/app/microempresario/services/microempresario.service';
import { ParametrosService } from 'src/app/services/parametros.service';
import { UserService } from 'src/app/services/user.service';
import { detalleSolicitud } from '../../models/detalle-solicitud';
import { RouterService } from 'src/app/services/router.service';
import { NeoIntermediarioFinancieroService } from 'src/app/intermediario/Service/neoIntermediarioFinanciero.service';
import axios from 'axios';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { CurrencyPipe } from '@angular/common';
import { TrazabilidadAuditoriaService } from 'src/app/intermediario/Service/trazabilidad-auditoria.service';
import { NeoTrazabilidadAuditoriaDTO } from 'src/app/intermediario/Model/neoTrazabilidadAuditoriaDTO';
import { Constantes } from '../../data/constantes';
import { PerfilSegmentoService } from 'src/app/microempresario/perfil/segmento/perfil-segmento.service';
import { resolveSegmento } from 'src/app/microempresario/perfil/segmento/perfil-segmento.util';

@Component({
    selector: 'detail-solicitud',
    templateUrl: './detalle-solicitud.component.html',
    styleUrls: ['./detalle-solicitud.component.scss'],
    standalone: false
})
export class DetalleSolicitudComponent implements OnInit {
  solicitud: detalleSolicitud;
  idSolicitud: string;
  personaNatural: boolean;
  idUsuario: string;
  idCliente: any;
  tipoUsuario: string;
  cantFile: number = 0;
  public detalleSolicitud: any;
  datosPropuestaBancoldex: boolean = false;
  datosPropuestaPropios: boolean = false;
  esIntermediario: boolean = false;
  historial: boolean = false;
  flujoCaja: boolean = false;
	// Observaciones gestion aliado
	formObservacionGestionAliado: UntypedFormGroup;
	listaObservaciones: any[] = [];
	isObserbacionGestion: boolean = false;
	idSolicitudIntermediario: string = '';
	observacionesAliados: any[] = [];

  idTrazabilidad: number = 0;

  isTransaccional: boolean = false;
  /** Redes normalizadas para UI (label + url). */
  redesVista: Array<{ label: string; url: string; href: string }> = [];
  private catalogoRedesNombres = new Map<number, string>();

  /** Destinos marcados (N:M) + texto libre de “Otro” (`solicitud.destino`). */
  destinosVista: Array<{
    idDestinoCredito: number;
    nombre: string;
    esOtro: boolean;
  }> = [];
  textoOtroDestino = '';
  /**
   * Solicitudes sin filas N:M pero con texto en `destino`.
   * Si hay destinos v2, el texto de Otro se muestra junto a esa opción.
   */
  mostrarDescripcionNecesidadLegacy = false;

  get descripcionNecesidad(): string {
    const opciones = this.destinosVista.map((destino) =>
      destino.esOtro && this.textoOtroDestino
        ? `${destino.nombre}: ${this.textoOtroDestino}`
        : destino.nombre
    );
    const textoEstaIncluido = this.destinosVista.some((destino) => destino.esOtro);
    if (this.textoOtroDestino && !textoEstaIncluido) {
      opciones.push(this.textoOtroDestino);
    }
    return opciones.join(', ');
  }

  /** Chrome y skin v2 solo si quien consulta es el microempresario. */
  get esVistaMicroempresario(): boolean {
    return this._user.getUser()?.actor === 'microempresario';
  }

constructor(
  private readonly route: ActivatedRoute,
  private readonly router: Router,
  private readonly _user: UserService,
  private readonly _microempresario: MicroempresarioService,
  private readonly _parametro: ParametrosService,
  private readonly _router: RouterService,
  private readonly _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
  private readonly _spinner: SpinnerService,
  private readonly _fb: UntypedFormBuilder,
  private readonly _sweetAlert: SweetAlertService,
  public _pipe: CurrencyPipe,
  private readonly _serviceTrazabilidad: TrazabilidadAuditoriaService,
  private readonly _segmento: PerfilSegmentoService
) {
    this.idSolicitud = this.route.snapshot.params.id;
    this.tipoUsuario = this.route.snapshot.params.persona;
    const user = this._user.getUser() || {};
    this.idUsuario = user.idUsuario ?? '0';
    this.idCliente = user.idCliente ?? '0';
    this.esIntermediario = user.actor == 'intermediario';
    window.scroll(0, 0);
    this.formObservacionGestionAliado = this._fb.group({
      observacionGestion: ['', Validators.required]
    })
    const nav = this.router.getCurrentNavigation();
    this.isTransaccional = nav?.extras.state?.['from'] === Constantes.TRANSACCIONAL;
  }

  ngOnInit(): void {
    this.cargarCatalogoRedes();
    this.getSolicitud();
    this.initDetalleSolicitud();
  }

  getSolicitud() {
    const json = {
      idSolicitud: +this.idSolicitud,
      usuario: +this.idUsuario,
    };
    this._parametro
      .getDetalleSolicitud(json)
      .subscribe((data: detalleSolicitud) => {
        this.solicitud = data;
        this.syncRedesVista();
        this.syncDestinosVista();
        this.revisionSolicitud();
        this.personaNatural = this.solicitud.InformacionBeneficiario.personaNatural;
        this.resolveMostrarFlujoCaja(data);
        this.cantFile = data.Documentos['archivos'].length;
        this.idSolicitudIntermediario = data.propuestaSeleccionada.idSolicitudIntermediario;
        if (this.solicitud.HistorialSolicitud.observacionBancoldex != null && this.tipoUsuario == 'intermediario'
          && this.solicitud.solicitud.idEstadoSolicitud_NeoEstadoSolicitud == 6) {
          this.historial = true;
        }
        if (data.Documentos['documentosCentralesRiesgo']?.length) {
          data.Documentos['documentosCentralesRiesgo'].sort((a, b) => {
            return a.idTipoDocumento_NeoTipoDocumento - b.idTipoDocumento_NeoTipoDocumento;
          });
        }
        if ((this.esIntermediario || this.tipoUsuario == 'intermediario') &&
          this.solicitud.solicitud.idEstadoSolicitud_NeoEstadoSolicitud == 11 &&
          this.solicitud.tieneFormalizacion.tooltip) {
          this.historial = true;
          this.isObserbacionGestion = true;
          this.getAvanzeFormalizacion(+this.idSolicitudIntermediario);
        }
        if (this.tipoUsuario == 'intermediario' &&
          this.solicitud.solicitud.idEstadoSolicitud_NeoEstadoSolicitud > 11 &&
          this.solicitud.formalizaciones.avances.length > 0) {
          this.isObserbacionGestion = false;
          this.observacionesAliados = data.formalizaciones.avances;
        }
        const body = {
          idSolicitud: this.idSolicitud,
          idCliente: Number(this.idCliente),
          idUsuario: Number(this.idUsuario),
        };
        this._neoIntermediarioFinancieroService
          .detalleAprobador(body)
          .subscribe((response) => {
            if (response['exitoso'] == true) {
              this.detalleSolicitud = response['data'];
              if (
                this.detalleSolicitud.propuesta?.origenRecursos ==
                'RECURSOS_BANCOLDEX'
              ) {
                this.datosPropuestaBancoldex = true;
                this.datosPropuestaPropios = false;
              }
              if (
                this.detalleSolicitud.propuesta?.origenRecursos == 'RECURSOS_PROPIOS'
              ) {
                this.datosPropuestaBancoldex = false;
                this.datosPropuestaPropios = true;
              }
            }
          });
      });
  }

  revisionSolicitud() {
    if (
      (this.esIntermediario || this.tipoUsuario == Constantes.INTERMEDIARIO) &&
      this.getSolicitudData("HistorialSolicitud", "EstadoIntermediario") == Constantes.PENDIENTE) {
      const body: NeoTrazabilidadAuditoriaDTO = {
        nombreSeccion: this.isTransaccional ? Constantes.TRANSACCIONAL : Constantes.HOME,
        nombrePantalla: Constantes.VER_DETALLE_SOLICITUD,
        idCliente: +this.idCliente,
        idUsuario: +this.idUsuario,
        idSolicitud: String(this.idSolicitud),
        perfil: this.tipoUsuario
      }
      this._serviceTrazabilidad.revisionSolicitud(body).subscribe(
        {
          next: resp => {
            this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
          },
          error: err => {
          }
        });
    }
  }

  getSolicitudData(key: string, subKey: string) {
    return this.solicitud[key][subKey];
  }

  /** BANCOLDEX | ALIADOS | AMBAS → etiqueta legible. */
  get tipoLineaLabel(): string {
    const raw = String(this.solicitud?.solicitud?.['tipoLinea'] ?? '')
      .trim()
      .toUpperCase();
    switch (raw) {
      case 'BANCOLDEX':
        return 'Bancóldex';
      case 'ALIADOS':
        return 'Aliados financieros';
      case 'AMBAS':
        return 'Ambas (Bancóldex y Aliados)';
      default:
        return raw || '—';
    }
  }

  /** PN express (PAR-069/PAR-068 + PAR-071): no muestra flujo. */
  private resolveMostrarFlujoCaja(data: detalleSolicitud): void {
    const flujo = data?.FlujoCaja;
    const tieneDatosFlujo =
      !!flujo &&
      flujo.mesCorteInformacion != undefined &&
      (flujo.mesCorteInformacion !== '' || Number(flujo.ventas) !== 0);

    if (!data?.InformacionBeneficiario?.personaNatural) {
      this.flujoCaja = tieneDatosFlujo;
      return;
    }

    this._segmento.ensureParamsLoaded().subscribe((params) => {
      const monto = Number(data.solicitud?.monto ?? 0);
      const plazo = Number(data.solicitud?.plazo ?? 0);
      this.flujoCaja = resolveSegmento(monto, plazo, params) === 'tradicional';
    });
  }

  goBack() {
    // Consumir servicio para finalizar auditoria
    this.cerrarTrazabilidad(this.idTrazabilidad);
    this._router.goBack();
  }

  cerrarTrazabilidad(idTrazabilidad: number) {
    this._serviceTrazabilidad.cierreTrazabilidad(idTrazabilidad).subscribe({
      next: resp => {
      },
      error: err => {
      }
    });
  }


  downloadFile(idDocumento: string, filename: string) {
    this._microempresario
      .downloadFile(idDocumento)
      .subscribe((response: any) => {
        const image: string = response.mimeType;
        if (
          response.mimeType === 'application/pdf'
        ) {
          const blob = new Blob([this.base64ToBytes(response.data)], {
            type: response.mimeType,
          });
          let urlFile = window.URL.createObjectURL(blob);
          this.router.navigate([]).then(() => window.open(urlFile));
        } else {
          var a = document.getElementById('downloadFile');
          a.setAttribute(
            'href',
            `data:${response.mimeType};base64,${response.data}`
          );
          a.setAttribute('download', unescape(filename));
          a.click();
        }
      });
  }

  base64ToBytes(base64: string) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  downloadAll() {
    const mymeType = 'application/zip';
    this._microempresario
      .downloadAllFile(this.idSolicitud)
      .subscribe((response: any) => {
        if (response.exitoso) {
          let a = document.getElementById('allFile');
          a.setAttribute(
            'href',
            `data:${mymeType};base64,${response.documentos}`
          );
          a.setAttribute('download', 'documentos.zip');
          a.click();
        }
      });
  }

  initDetalleSolicitud() {
    this.solicitud = {
      Documentos: [],
      HistorialSolicitud: {
        EstadoActual: '',
        FechaPrevista: '',
        LaSolicitudSeEnvioEl: '',
        fechaActual: '',
        observaciones: '',
        observacionBancoldex: ''
      },
      InformacionBeneficiario: {
        AnioDeActivos: '',
        AnioDeVentas: '',
        barrioEmpresa: '',
        CiudadResidencia: [],
        DepartamentoResidencia: [],
        EstadoCivil: '',
        FechaDeExpedicionDelDocumento: '',
        FechaDeNacimiento: '',
        Genero: '',
        NivelDeActivos: 0,
        NivelDeEstudios: '',
        NivelDeVentas: 0,
        NombreDeContacto: '',
        NumeroDeDocumento: '',
        PagaSeguridadSocial: '',
        PrimerApellido: '',
        PrimerNombre: '',
        SegundoApellido: '',
        SegundoNombre: '',
        TipoDeDocumentoDeIdentidad: '',
        TipoDeVivienda: '',
        personaNatural: false,
        DireccionDeResidencia: '',
        creditoAnterior: '',
        puntajeScoreExperian: '',
        puntajeScoreTransunion: ''
      },
      propuestaSeleccionada: {
        idSolicitudIntermediario: '',
        idPropuesta: 0,
        cuota: 0,
        desembolsoAproximado: 0,
        monto: 0,
        nombreIntermediario: '',
        origenRecursos: '',
        plazo: 0,
        tasa: 0,
        periodicidad: 0,
        observaciones: 0,
        neoCargoComisiones: [],
      },
      solicitud: {
        idEstadoSolicitud_NeoEstadoSolicitud: 0,
        monto: 0,
        plazo: 0,
        destino: '',
      },
      formalizaciones: {
        avances: [],
      },
      tieneFormalizacion: {
        tooltip: false,
      },
      FlujoCaja: {
        mesCorteInformacion: '',
        ventas: 0,
        otrosIngresos: 0,
        fuenteOtrosIngresos: '',
        pagoProveedores: 0,
        pagoArriendo: 0,
        pagoAdministracion: 0,
        pagoServiciosPublicos: 0,
        pagoSueldoPropio: 0,
        pagoSueldoEmpleados: 0,
        pagoPlanCelular: 0,
        pagoTarjetaCredito: 0,
        pagoCuotaCreditos: 0,
        SaldoDeudas: 0,
        pagoOtrosGastos: 0,
        fuenteOtrosGastos: '',
        totalGastos: 0,
        totalIngresos: 0,
        efectivoDisponible: 0
      },
      redesSociales: [],
    };
  }

  /** Carga nombres del catálogo (Instagram, Facebook, …) para etiquetar redes. */
  private cargarCatalogoRedes(): void {
    this._parametro.getRedesSocialesPerfil().subscribe({
      next: (res: unknown) => {
        const rows = Array.isArray(res)
          ? res
          : Array.isArray((res as { data?: unknown })?.data)
            ? (res as { data: unknown[] }).data
            : [];
        this.catalogoRedesNombres.clear();
        for (const row of rows as Array<{
          idCatalogoRedSocial?: number;
          nombre?: string;
        }>) {
          if (row?.idCatalogoRedSocial != null && row.nombre) {
            this.catalogoRedesNombres.set(
              Number(row.idCatalogoRedSocial),
              String(row.nombre)
            );
          }
        }
        this.syncRedesVista();
      },
      error: () => {
        this.syncRedesVista();
      },
    });
  }

  private syncRedesVista(): void {
    const raw = (this.solicitud as any)?.redesSociales;
    if (!Array.isArray(raw) || raw.length === 0) {
      this.redesVista = [];
      return;
    }
    this.redesVista = raw
      .map((item: unknown) => this.normalizeRedItem(item))
      .filter((r): r is { label: string; url: string; href: string } => !!r);
  }

  private syncDestinosVista(): void {
    const raw = (this.solicitud as any)?.destinosCredito;
    const destinoTexto = String(
      (this.solicitud as any)?.solicitud?.destino ?? ''
    ).trim();
    this.textoOtroDestino = destinoTexto;

    if (!Array.isArray(raw) || raw.length === 0) {
      this.destinosVista = [];
      // Solicitudes previas: solo textarea destino, sin N:M.
      this.mostrarDescripcionNecesidadLegacy = destinoTexto.length > 0;
      return;
    }

    this.destinosVista = raw
      .map((item: unknown) => {
        if (!item || typeof item !== 'object') {
          return null;
        }
        const row = item as {
          idDestinoCredito?: number | string;
          nombre?: string;
          esOtro?: boolean | number;
        };
        const id = Number(row.idDestinoCredito);
        const nombre = String(row.nombre ?? '').trim();
        if (!Number.isFinite(id) || !nombre) {
          return null;
        }
        const esOtro =
          row.esOtro === true || row.esOtro === 1 || Number(row.esOtro) === 1;
        return { idDestinoCredito: id, nombre, esOtro };
      })
      .filter(
        (
          d
        ): d is { idDestinoCredito: number; nombre: string; esOtro: boolean } =>
          !!d
      );

    // Con destinos N:M, el texto de Otro va junto a esOtro; si hay texto huérfano, textarea anterior.
    this.mostrarDescripcionNecesidadLegacy =
      destinoTexto.length > 0 && !this.destinosVista.some((d) => d.esOtro);
  }

  private normalizeRedItem(
    item: unknown
  ): { label: string; url: string; href: string } | null {
    let url = '';
    let idCatalogo: number | null = null;
    if (typeof item === 'string') {
      url = item.trim();
    } else if (item && typeof item === 'object') {
      const row = item as {
        url?: string;
        idCatalogoRedSocial?: number | null;
      };
      url = String(row.url ?? '').trim();
      if (row.idCatalogoRedSocial != null) {
        idCatalogo = Number(row.idCatalogoRedSocial);
      }
    }
    if (!url) {
      return null;
    }
    const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    const fromCatalog =
      idCatalogo != null ? this.catalogoRedesNombres.get(idCatalogo) : undefined;
    return {
      label: fromCatalog || this.labelFromUrl(url),
      url,
      href,
    };
  }

  private labelFromUrl(url: string): string {
    const lower = url.toLowerCase();
    if (lower.includes('facebook') || lower.includes('fb.com')) {
      return 'Facebook';
    }
    if (lower.includes('instagram')) {
      return 'Instagram';
    }
    if (lower.includes('tiktok')) {
      return 'TikTok';
    }
    if (lower.includes('linkedin')) {
      return 'LinkedIn';
    }
    if (lower.includes('youtube') || lower.includes('youtu.be')) {
      return 'YouTube';
    }
    if (lower.includes('twitter') || lower.includes('x.com')) {
      return 'X (Twitter)';
    }
    if (lower.includes('whatsapp') || lower.includes('wa.me')) {
      return 'WhatsApp';
    }
    return 'Red social';
  }

  downloadImages(url, name) {
    this._spinner.showSpinner();
    axios(url, {
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this._spinner.hiddenSpinner();
      })
      .catch((e) => {
        this._spinner.hiddenSpinner();
        console.log(e);
      });
  }
  // Observaciones gestion aliado
  getAvanzeFormalizacion(idSolicitudIntermediario: number) {
    this._neoIntermediarioFinancieroService
      .getSolicitudAvanceFormalizacion(idSolicitudIntermediario)
      .subscribe((data: any) => {
        if (data.exitoso) {
          this.observacionesAliados = data.avances;
        }
      });

  }

  validarObservacion(field: string) {
    return (
      (this.formObservacionGestionAliado.get(field).dirty || this.formObservacionGestionAliado.get(field)?.touched) &&
      this.formObservacionGestionAliado.get(field)?.invalid
    );
  }

  addRow() {
    let json: { idUsuario: number, observacion: string, idSolicitudIntermediario: number }
    let aux = this.formObservacionGestionAliado.get('observacionGestion').value;
    json = {
      idUsuario: +this.idUsuario,
      observacion: aux,
      idSolicitudIntermediario: +this.idSolicitudIntermediario
    }
    if (aux != '') {
      this.listaObservaciones.push(json);
      this.formObservacionGestionAliado.get('observacionGestion').reset();
      this.saveObservaciones(json);
    } else {
      this._sweetAlert.infoModal('La observación no puede ser nula', true);
    }
  }

  saveObservaciones(body: any) {
    this._neoIntermediarioFinancieroService.saveObservacionesAvanceFormalizacion(body)
      .subscribe((response: any) => {
        if (response.exitoso) {
          this.getAvanzeFormalizacion(body.idSolicitudIntermediario)
          this.listaObservaciones = []
        } else {
          this._sweetAlert.errorModal("Error", true, 'No fue posible guardar cambios');
        }
      }, (error) => {
        this._sweetAlert.errorModal("Error", true, 'Error en el servicio');
      })
  }

  separarString(cadena: string) {
    const pattern = /([A-Z]?[^A-Z]*)/g
    let salida = cadena.replace(pattern, ' $1').replace(/^./, (str) => {
      return str.toUpperCase();
    })
    return salida;
  }
}
